import styles from './Labels.module.css';
import ResultAndCount from '../../components/ResultAndCount/ResultAndCount';
import SearchBar from '../../components/SearchBar/SearchBar';
import Dropdown from '../../components/Dropdown/Dropdown';
import { IoMdTrash } from 'react-icons/io';
import Dynamic from '../../components/DynamicTable/DynamicTable';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import { useState } from 'react';
import PaginationTable from '../../components/PaginationTable/PaginationTable';
import LogoWithName from '../../components/LogoWithName/LogoWithName';
import Action from '../../components/Action/Action';
import FixedLogoWithName from '../../components/FixedLogoWithName/FixedLogoWithName';
import IconAndName from '../../components/IconAndName/IconAndName';
import { IoAddCircleOutline } from 'react-icons/io5';
import CopyRight from '../../components/CopyRight/CopyRight';

const data = [
  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'blue',
  },
  { _id: 'id1', LabelName: 'king', color: 'var(--Warning_Color)' },
  { _id: 'id2', LabelName: 'queen', color: 'var(--Info_Color)' },
  { _id: 'id3', LabelName: 'jack', color: 'var(--Success_Color)' },
  { _id: 'id4', LabelName: 'ace', color: 'var(--Info_Color)' },
  // and so on with unique ids...

  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'var(--Warning_Color)',
  },
  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'var(--Info_Color)',
  },
  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'blue',
  },
  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'blue',
  },
  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'blue',
  },
  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'blue',
  },

  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'blue',
  },
  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'blue',
  },
  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'blue',
  },
  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'blue',
  },
  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'blue',
  },
  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'blue',
  },
  {
    _id: 'gnswkgnseknsg1',
    LabelName: 'king',
    color: 'blue',
  },
];

function Labels() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleLabel = () => {
    dispatch(openModal('addLabel'));
  };
  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        LabelName: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              style={{ width: 'max-content' }}
              type="checkbox"
              checked={isChecked}
              onChange={(e) => {
                const checked = e.target.checked;
                setSelectedIds((prev) =>
                  checked
                    ? [...prev, item._id]
                    : prev.filter((id) => id !== item._id)
                );
              }}
            />
            <FixedLogoWithName
              Roomname={item.LabelName}
              color={item.color || 'green'}
            />
          </div>
        ),

        Action: (
          <div>
            <IoMdTrash
              size={20}
              style={{
                color: 'var(--Warning_Color)',
                cursor: 'pointer',
                margin: 'auto',
              }}
              onClick={() => dispatch(openModal('delete'))}
            />
          </div>
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <input
            type="checkbox"
            style={{ width: 'max-content' }}
            checked={selectedIds.length === data.length}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds(checked ? data.map((item) => item._id) : []);
            }}
          />
          Label Name
        </div>
      ),
      accessor: 'LabelName',
    },

    { title: 'Action', accessor: 'Action' },
  ];

  return (
    <>
      <div className={styles.headerContainer}>
        {/* Status boxes */}

        {/* Search and Filters */}
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar
                placeholder="Search label "
                onChange={(e) => console.log(e.target.value)}
              />
            </div>
            <div className={styles.Addroom}>
              <Dropdown
                bgColor="var(--Utility_Color1)"
                label="Activity"
                options={['YourActivity1', 'YourActivity2', 'YourActivity3']}
              />
              <IconAndName
                icon={<IoAddCircleOutline />}
                title="Add Label"
                bgColor="Primary_Color"
                onClick={handleLabel}
              />
              <IoMdTrash
                size={26}
                style={{
                  opacity: 0.4,
                  color: 'var(--Black_Color)',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  dispatch(openModal('delete'));
                }}
              />
            </div>
          </div>

          {/* Student Data Table */}
          <div className={styles.dynamicdata}>
            <Dynamic
              headings={headingsData}
              columnData={displayData.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
              )}
            />
          </div>
          <div className={styles.paginationTable}>
            <PaginationTable
              data={displayData}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </div>
      </div>
      <div>
        <CopyRight />
      </div>
    </>
  );
}

export default Labels;
